import classes from '@/components/Shares/Input.module.css';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { gunterzBlack } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Group, PasswordInput, Stack, Text, TextInput, rem } from '@mantine/core';
import Link from 'next/link';
import { AuthModalLayout } from './AuthModalLayout';
import { PlayButton } from './PlayButton';
import { SocialLinks } from './SocialLinks';
export const Register: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    openModal,
    setOpenModal
  } = useModalAction();
  return <AuthModalLayout opened={openModal === MODAL.REGISTER} handleClose={() => setOpenModal(null)}>
      <Stack gap={10} mx="auto" pb={{
      base: 268,
      md: 370,
      lg: 254
    }} w={{
      base: '100%',
      sm: rem(524),
      xl: rem(427)
    }}>
        <Text mb={10} component="h2" fz="h2" ta="center" tt="uppercase" c="var(--text-prime)" className={gunterzBlack.className}>
          {i18n._('Register')}
        </Text>

        <TextInput radius="sm" placeholder="Username" size="md" classNames={{
        input: classes.input_style_2
      }} />
        <TextInput radius="sm" placeholder="Email" size="md" classNames={{
        input: classes.input_style_2
      }} />
        <PasswordInput radius="sm" type="password" placeholder="Password" size="md" classNames={{
        input: classes.input_style_2,
        innerInput: classes.innerInput
      }} />

        <Group justify="center">
          <Text mt={20} component={Link} href="#" tt="uppercase" ta="center" fz="xs" fw={700} w={{
          base: '90%',
          sm: '80%',
          md: '100%'
        }} c="var(--text-dark)">
            {i18n._('By clicking the button I agree to the ')}
            <Text span inherit c="var(--text-blue)">
              {i18n._('User Agreement')}
            </Text>
            {i18n._(' & confirm I am at least 18 years old')}
          </Text>
        </Group>
        <PlayButton />

        <Stack align="center" gap={20}>
          <Text tt="uppercase" mt={20} fz="xs" fw={700} c="var(--text-dark)" onClick={() => setOpenModal(MODAL.LOGIN)}>
            {i18n._('Already have an account?')}

            <Text td="underline" c="#0084FF" span inherit ml={4} style={{
            cursor: 'pointer'
          }}>
              {i18n._('Sign In')}
            </Text>
          </Text>

          <SocialLinks />
        </Stack>
      </Stack>
    </AuthModalLayout>;
};